import React from 'react';

const Footer = () => {
  return (
    <footer className="mt-20 py-12" style={{ background: '#020409', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
      <div className="mx-auto max-w-[1140px] flex flex-col items-center">
        <div className="flex items-center gap-2 text-white mb-6">
          <span className="text-[22px] font-extrabold tracking-tight" style={{ fontFamily: '"Inter", sans-serif' }}>OpenBro</span>
          <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" aria-hidden="true"><path fill="#fff" d="M12 0c.6 7.2 4.8 11.4 12 12-7.2.6-11.4 4.8-12 12-.6-7.2-4.8-11.4-12-12 7.2-.6 11.4-4.8 12-12z" /></svg>
        </div>
        <p
          className="text-[rgba(255,255,255,0.5)] text-[13px] text-center"
          style={{ fontFamily: '"Inter", sans-serif' }}
        >
          &copy; {new Date().getFullYear()} OpenBro. Le mentorat de Gaut Bonac.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
